import type { AvatarConfig } from '../api/types';

export type RoutePosition={x:number;y:number;moving:boolean;heading?:number};

export function routePosition(avatar:AvatarConfig,seconds:number,width:number,depth:number):RoutePosition {
  const points=avatar.points?.length?avatar.points:[{x:50,y:50,wait:0}];
  const segments=points.map((p,i)=>{
    const next=points[(i+1)%points.length];
    const dx=(next.x-p.x)*width/100,dy=(next.y-p.y)*depth/100;
    return {p,next,dx,dy,wait:p.wait||0,duration:Math.hypot(dx,dy)/(avatar.speed||1)};
  });
  const total=segments.reduce((n,s)=>n+s.wait+s.duration,0);
  if(total<=0)return {...points[0],moving:false};
  let phase=Math.max(0,seconds)%total;
  for(const segment of segments){
    if(phase<segment.wait)return {x:segment.p.x,y:segment.p.y,moving:false};
    phase-=segment.wait;
    if(phase<segment.duration){
      const t=phase/segment.duration;
      return {x:segment.p.x+(segment.next.x-segment.p.x)*t,y:segment.p.y+(segment.next.y-segment.p.y)*t,moving:true,
        heading:Math.atan2(segment.dx-segment.dy,(segment.dx+segment.dy)/2)};
    }
    phase-=segment.duration;
  }
  return {...points[0],moving:false};
}
